module.exports = __webpack_public_path__ + "static/media/air-à-domicile.64c094a6.png";